// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class ProfaneWordMatch{
  profaneText: string;
  index: number;
  length: number;
}
